import { Inject, Injectable } from '@angular/core';
import { App, AppKey, AppPartnerService } from '@galaxy/marketplace-apps';
import { Order } from '@vendasta/sales-orders';
import { Observable, of } from 'rxjs';
import { AppSdkService } from '../line-items/line-items.interface';
import { WorkOrderSalesOrderSummaryInfo } from '@vendasta/work-order';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { FulfillmentOrder } from '@vendasta/order-fulfillment';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderDetailsHelperService {
  constructor(@Inject(AppPartnerService) private readonly appSdk: AppSdkService) {}

  private getAppsOnOrder(productIds: string[], order: Order): Observable<App[]> {
    if (productIds?.length < 1) {
      return of([]);
    }
    return this.appSdk.getMulti(
      productIds.map((productId) => new AppKey({ appId: productId })),
      order.partnerId,
      order.marketId,
      null,
      true,
    );
  }

  getWorkOrdersForSalesOrder(
    order: Order,
    workOrdersHasForms$: Observable<boolean[]>,
    workOrdersForSalesOrder$: Observable<FulfillmentOrder[]>,
  ): Observable<WorkOrderSalesOrderSummaryInfo[]> {
    return workOrdersForSalesOrder$.pipe(
      switchMap((workOrders) => {
        return this.getAppsOnOrder(
          workOrders?.map((wo) => wo.appId),
          order,
        ).pipe(
          withLatestFrom(workOrdersHasForms$),
          map(([apps, hasForms]) => {
            return workOrders.map((wo, i) => {
              const app: App = apps.find((app) => app?.key?.appId === wo.appId);
              return {
                appName: app?.sharedMarketingInformation?.name,
                appIconUrl: app?.sharedMarketingInformation?.iconUrl,
                workOrderId: wo.fulfillmentOrderId,
                workOrderStatus: wo.status,
                workOrderLandingPageRouterLinkUrl: `../../work-order/${wo.salesOrderId}`,
                hasForm: hasForms[i],
              } as WorkOrderSalesOrderSummaryInfo;
            });
          }),
        );
      }),
    );
  }
}
